import { type TemplateOnlyComponent } from '@ember/component/template-only';
import PageLoading from 'dashboard/components/page-loading';

const Loading: TemplateOnlyComponent = <template><PageLoading /></template>;

export default Loading;
